module.exports = __webpack_public_path__ + "img/q7.a5ea0859.gif";